export enum MixpanelCounter {
  Vote = 'Vote',
  Claim = 'Claim',
  Unbond = 'Unbond',
  Delegate = 'Delegate',
  ClaimAll = 'Claim All',
  BidCount = 'Bid Count',
  Redelegate = 'Re-delegate',
  ConnectClicked = 'Connect Clicked',
  KadoBannerClicked = 'Kado Banner Clicked'
}

export enum MixpanelEvent {
  Vote = 'Vote',
  Login = 'Login',
  Claim = 'Claim',
  Unbond = 'Unbond',
  Delegate = 'Delegate',
  BidCount = 'Bid Count',
  PlaceBid = 'Place bid',
  ClaimAll = 'Claim All',
  Redelegate = 'Re-delegate',
  ConnectClicked = 'Connect Clicked',
  WalletSelected = 'Wallet Selected',
  DarkThemeToggled = 'Dark Theme Toggled',
  KadoBannerClicked = 'Kado Banner Clicked',
  ChangeSelectedLanguage = 'Change Selected Language',
  InitialSelectedLanguage = 'Initial Selected Language'
}
